class ShoppingRoutenPage {
    constructor() {
        this.routeAside = $('.page--srp__aside');
        this.routeFacts = $('.page--srp__teaser__facts');
        this.mainContainer = $('.main');
        this.breakpoint = 1100;

        if (window.innerWidth > this.breakpoint) {
            this.positionRouteAside();
            this.setCurrentStation();
        } else {
            this.positionRouteAsideReset();
        }
    }

    positionRouteAsideReset() {
        // Aside Positionierung nur auf dem Desktop
        // setzte mindeshlhe of main Container
        // @TODO Breite abfragen
        const that = this;

        that.routeAside.attr('style', '');
    }

    positionRouteAside() {
        // Aside Positionierung nur auf dem Desktop
        // setzte mindeshlhe of main Container
        // @TODO Breite abfragen
        const that = this;
        let positionRouteFacts = that.routeFacts[0].getBoundingClientRect().top +
            that.routeFacts[0].ownerDocument.defaultView.pageYOffset;
        that.routeAside
            .css('top', positionRouteFacts + 'px')
            .css('min-height', that.mainContainer.height());
    }

    setCurrentStation() {
        // aktiviert die aktuelle Station
        const that = this;
        const stationNavEntries = $('.page--srp__shortlist li');
        const stationShopInfos = $('.page--srp__entry__info');

        if (!!window.IntersectionObserver) {

            const routeStations = document.querySelectorAll(".page--srp__entry");
            const observerOptions = {rootMargin: "0px 0px 0"};

            const observerForActiveRouteStations = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const currentStation = entry.target.getAttribute("data-entry-srp");
                        //stationNavEntries.removeClass('current');
                        $('[data-nav-srp="' + currentStation + '"]').addClass('current');

                        //stationShopInfos.removeClass('opacity--1');

                        $('[data-shopinfo-srp="' + currentStation + '"]').addClass('opacity--1');
                    }
                });
            }, observerOptions);

            routeStations.forEach(function (station) {
                observerForActiveRouteStations.observe(station);
            });
        }
    }
}